import axios from 'axios';
import actions from '../actions/user';
import role from '../../helpers/role';

export default {
	namespaced: true,
	state: {
		user: JSON.parse(localStorage.getItem('user')) || {},
		roles: JSON.parse(localStorage.getItem('roles')) || [],
		organization: [],
	},
	mutations: {
		[actions.SET_USER]: (state, user) => {
			state.user = user;
		},
		[actions.SET_USER_ROLES]: (state, roles) => {
			state.roles = roles;
		},
		[actions.CLEAR]: (state) => {
			state.user = {};
			state.roles = {};
		},
	},
	actions: {
		[actions.SET_USER]: ({ commit }, user) => {
			localStorage.setItem('user', JSON.stringify(user));
			commit(actions.SET_USER, user);
		},
		[actions.SET_USER_ROLES]: ({ commit }, roles) => {
			localStorage.setItem('roles', JSON.stringify(roles));
			commit(actions.SET_USER_ROLES, roles);
		},
		[actions.CLEAR]: ({ commit }) => {
			commit(actions.CLEAR);
		},
		[actions.GET_CURRENT_USER]: async ({ dispatch, rootState }) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'current_user_details');
				const response = await axios.get(link.href);

				const { data } = response;
				dispatch(actions.SET_USER, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_USER_ROLES]: async ({ state, dispatch, rootState }, organizationId) => {
			try {
				const link = rootState.root.links.find(x => x.rel === 'roles' && x.templated);

				const href = link.href
					.replace('{id}', state.user.id)
					.replace('{organizationId}', organizationId);

				const response = await axios.get(href);

				const { data } = response;
				dispatch(actions.SET_USER_ROLES, data);
			} catch (error) {
				throw error;
			}
		},
		[actions.GET_ORGANIZATIONS]: async ({ state }) => {
			let organizations = [];

			try {
				const response = await axios.get(`user/${state.user.id}/organizations`);

				const { data } = response;

				organizations = data;
			} catch (error) {
				throw error;
			}

			return organizations;
		},
		[actions.GET_USERS]: async ({ rootState }) => {
			let users = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'users_for_selectors');
				const response = await axios.get(link.href);

				const { data } = response;

				users = data;
			} catch (error) {
				throw error;
			}

			return users;
		},
		[actions.GET_USER]: async ({ rootState }, id) => {
			let users = [];

			try {
				const link = rootState.root.links.find(x => x.rel === 'get_user_by_id');
				const href = link.href.replace('{id}', id);
				const response = await axios.get(href);

				const { data } = response;

				users = data;
			} catch (error) {
				throw error;
			}

			return users;
		},
	},
	getters: {
		User: state => state.user,
		HasUser: state => !!state.user,
		HasRoles: state => !!state.roles && state.roles.length > 0,
		Roles: state => state.roles,
		LanguageCode: state => state.user.languageCode,
		IsAdmin: state => state.roles.some(x => x.code === role.OrgAdmin),
		IsRecordAdmin: state => state.roles.some(x => x.code === role.RecordAdmin),
		IsManualBestlistAdmin: state => state.roles.some(x => x.code === role.ManualBestlistAdmin),
		IsLicenser: state => state.roles
			.some(x => x.code === role.OrgAdmin
                || x.code === role.OrgUser
                || x.code === role.Official),
		IsAdminForOrg: state => id => state.user.userRoles
			.some(x => x.organizationId === id && x.role.code === role.OrgAdmin),
		IsStatistiker: state => state.roles.some(x => x.code === role.Statistiker),
		IsApprover: state => state.roles.some(x => x.code === role.Approver),
		IsGerman: state => ('4dfa9c23-d158-46b5-bbff-96b0126b97e8').includes(state.user.masterOrganization.value), //Hacky but fast (from Andy)
	},
};
